var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.67 70.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.67,
    height: 70.67,
    fill: "#000",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.97,15.28c2.37,1.2,4.19,2.89,5.46,5.06,1.27,2.18,1.9,4.69,1.9,7.53,0,2.29-.4,4.45-1.19,6.49-.8,2.04-1.95,3.68-3.45,4.94-1.51,1.26-3.29,1.88-5.36,1.88-1.45,0-2.62-.3-3.52-.9-.89-.6-1.46-1.46-1.72-2.57-.81,1.09-1.86,1.95-3.14,2.57-1.28.63-2.64.94-4.06.94-2.12,0-3.78-.63-4.98-1.9-1.2-1.27-1.8-3.01-1.8-5.21s.43-4.04,1.3-5.86c.86-1.81,2.06-3.27,3.6-4.37,1.53-1.1,3.26-1.65,5.19-1.65,2.4,0,4.05.84,4.94,2.51l.38-2.18h4.9l-1.97,11.3c-.08.53-.13,1.02-.13,1.46,0,.67.14,1.17.42,1.51s.75.5,1.42.5c1,0,1.85-.47,2.53-1.42.68-.95,1.2-2.13,1.55-3.56.35-1.42.52-2.85.52-4.27,0-3.38-1.03-5.99-3.1-7.85-2.07-1.86-4.98-2.78-8.75-2.78-3.21,0-6.11.77-8.7,2.32-2.6,1.55-4.62,3.66-6.09,6.32-1.46,2.66-2.2,5.63-2.2,8.89,0,3.46,1.03,6.12,3.08,7.99,2.05,1.87,4.96,2.8,8.73,2.8,2.71,0,5.09-.49,7.16-1.46l.84,3.85c-2.65,1.12-5.59,1.67-8.83,1.67s-5.86-.59-8.2-1.78c-2.34-1.19-4.16-2.87-5.44-5.04-1.28-2.18-1.93-4.7-1.93-7.57,0-4.1.96-7.83,2.87-11.17,1.91-3.35,4.56-5.98,7.95-7.91,3.39-1.93,7.19-2.89,11.4-2.89,3.24,0,6.04.6,8.41,1.8ZM36.51,36c.84-.59,1.5-1.37,1.99-2.34.49-.98.73-2.02.73-3.14,0-1.17-.32-2.12-.96-2.85-.64-.73-1.53-1.09-2.68-1.09-1.03,0-1.94.31-2.72.94-.78.63-1.39,1.44-1.82,2.45-.43,1-.65,2.06-.65,3.18s.28,2.05.84,2.72c.56.67,1.39,1,2.51,1,1,0,1.93-.29,2.76-.88Z",
    fill: "#fff",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 63.91,
    width: 70.67,
    height: 6.76,
    fill: "#785abf",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.a622a79a42269ce7435325673ba62629.svg";
export { ForwardRef as ReactComponent };